var g = /* @__PURE__ */ ((t) => (t.md = "md", t.medium = "medium", t.lg = "lg", t.large = "large", t))(g || {}), n = /* @__PURE__ */ ((t) => (t.fill = "fill", t.fillLight = "fillLight", t.outline = "outline", t))(n || {});
const r = (t) => {
  switch (t) {
    case "fill":
      return "button-toggle-fill";
    case "fillLight":
      return "button-toggle-fill-light";
    case "outline":
      return "button-toggle-outline";
    default:
      return "button-toggle-fill";
  }
}, u = (t) => {
  switch (t) {
    case "large":
    case "lg":
      return "button-toggle-lg";
    case "medium":
    case "md":
      return "button-toggle-md";
    default:
      return "button-toggle-md";
  }
}, s = (t) => {
  const l = u(t.size), e = r(t.variant);
  return `${l} ${e}`;
};
export {
  g as ButtonToggleSize,
  n as ButtonToggleVariant,
  s as getToggleButtonStyleClasses
};
